function percent(value) {
    return `${value}%`;
}
export { percent };
